import React from "react";
// Limitless imports
import { PortalApp, RestrictedAppConfigContextProvider } from "@limitless/portal";
import { ExpertHeaderLifecycleProvider, ExpertRatingContextProvider, ExpertLifecycleProvider } from "@limitless/expert";
import { AnalyticsContextProvider } from "@limitless/analytics";
import Routes from "./routes/Routes";
import ErrorBoundaryWrapper from "./ErrorBoundaryWrapper";

const ExpertWebApp = () => {
    return (
        <PortalApp>
            <ErrorBoundaryWrapper>
                <RestrictedAppConfigContextProvider>
                    <ExpertHeaderLifecycleProvider>
                        <ExpertRatingContextProvider>
                            <AnalyticsContextProvider>
                                <Routes />
                            </AnalyticsContextProvider>
                        </ExpertRatingContextProvider>
                    </ExpertHeaderLifecycleProvider>
                </RestrictedAppConfigContextProvider>
            </ErrorBoundaryWrapper>
        </PortalApp>
    );
};

export default ExpertWebApp;
